export const promptTypes = {
  CANCEL: 'cancel',
  ERROR: 'error',
  EXIT_PAGE: 'exitPage',
  REQUIRED_FIELDS: 'requiredFields',
};
